import React from "react";
import {createRoot} from 'react-dom/client';
import Home from "./pages";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Support from "./pages/Support";
import CueEditor from "./pages/cueEditor/CueEditor";
import InvitePage from "./pages/InvitePage";
import {ChakraProvider} from "@chakra-ui/react";
import FirebaseAuth from "./auth/FirebaseAuth";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import {UserContextProvider} from "./UserContext";
import {ConnectionProvider} from "./ConnectionProvider";
import {ConfirmDialogProvider} from "./components/common/ConfirmDialogProvider";
import {TranslationDialogProvider} from "./components/translations/TranslationDialogProvider";
import PublicConnectionProvider from "./PublicConnectionProvider";
import PublicAreaListPage from "./pages/PublicAreaListPage";

const Index = () => {
    return <ChakraProvider>
        <Router>
            <Routes>
                <Route path={"/"} element={<LandingPage/>}/>
                <Route path={"/privacy"} element={<PrivacyPolicy/>}/>
                <Route path={"/support"} element={<Support/>}/>
                <Route path={"/spaces"} element={
                    <PublicConnectionProvider>
                        <PublicAreaListPage/>
                    </PublicConnectionProvider>
                }/>
                <Route path={"/areas"} element={<Navigate to={"/spaces"} replace/>}/>
                <Route path={"/cue-editor"} element={<CueEditor/>}/>
                <Route path={"/invite"} element={
                    <FirebaseAuth>
                        <ConnectionProvider>
                            <InvitePage/>
                        </ConnectionProvider>
                    </FirebaseAuth>
                }/>
                <Route path={"/app"} element={
                    <FirebaseAuth>
                        <ConnectionProvider>
                            <UserContextProvider>
                                <ConfirmDialogProvider>
                                    <TranslationDialogProvider>
                                        <Home/>
                                    </TranslationDialogProvider>
                                </ConfirmDialogProvider>
                            </UserContextProvider>
                        </ConnectionProvider>
                    </FirebaseAuth>
                }/>
            </Routes>
        </Router>
    </ChakraProvider>
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);
root.render(<Index/>);
